<template>
  <div :class="['ph-app__container', 'logo']">
    <template v-if="creative">
      <img class="ph-app__background" :src="DEFAULT_BG_URL"/>
      <span class="ph-app__perview ph-icon__perview">
        <img class="ph-icon__perview-img" :src="DEFAULT_PREVIEW_URL" />
        <div v-if="creative['tabbars']" class="ph-icon__perview-tabbar">
          <div v-for="(item, index) in iconList" :key="index" :class="`ph-icon__perview-bar ph-icon__perview-bar-${index + 1}`">
            <div class="ph-icon__perview-bar__blank" />
            <img :src="item" />
          </div>
        </div>
        <div v-else class="ph-icon__perview-tabbar">
          <div v-for="index in 5" :key="index" :class="`ph-icon__perview-bar ph-icon__perview-bar-${index}`">
            <div class="ph-icon__perview-bar__blank" />
            <img :src="require(`@assets/tabbar_icon/tabbar_lightskin_${index}.png`)" />
          </div>
        </div>
      </span>
    </template>
    <ph-dialog
      title="取消后首页底导皮肤将以默认样式展示"
      :show.sync="show"
      :showCancelButton="true"
      @confirm="onSure"
      @cancel="onCancel"
    />
    <ph-button
      class="ph-app__action"
      v-if="!wore && creative"
      :disabled="iLoading || isNotStart || isOver"
      type="primary"
      size="large"
      @click="putOn"
    >
      {{statusText}}
    </ph-button>
    <ph-button
      class="ph-app__action"
      v-if="wore && creative"
      :disabled="iLoading"
      type="primary"
      size="large"
      @click="showDialog"
    >
      取消底导皮肤
    </ph-button>
    <div
      v-if="isNotStart&&creative"
      class="ph-app__time"
    >
      活动将于{{startTime}}开始
    </div>
    <ph-checkbox
      v-if="showAgreement"
      v-model="agreement"
      class="ph-app__checkbox"
    >
      同步到微博
    </ph-checkbox>
  </div>
</template>

<script>
import dayjs from 'dayjs';
import toast from '@components/toast';
import PhDialog from '@components/dialog';
import PhButton from '@components/button';
import PhCheckbox from '@components/checkbox';
import {cheka, CHEKA_EVENTS} from '@utils/cheka';
import jsBridge from '@utils/jsbridge';
import {CAMPAIGN_STATUS} from '@data/campaignStatus';
import {IS_FEED_STATUS} from '@data/isFeed';
import creativeService from '@services/creative';
import {getUrlParam} from '@utils/url';
import { POS_MAP } from '@data/posMap';
import '@styles/index';

const MIN_VERSION = 'D71';
const CHANNEL_URL = 'https://jianye.hd.weibo.com/site/minisite/20230719mihayou';
const CHANNEL_NAME = 'mihayou';


const DEFAULT_BG_URL = 'http://wx4.sinaimg.cn/large/006jAPCKly8hhfwrgl75yj30n01dsdow.jpg';
const DEFAULT_PREVIEW_URL = 'https://js.t.sinajs.cn/weiboad/apps/ka/uploads/bg_1.png';

export default {
  name: 'Icon',
  components: {
    PhDialog,
    PhButton,
    PhCheckbox
  },
  data() {
    return {
      DEFAULT_BG_URL,
      DEFAULT_PREVIEW_URL,
      show: false,
      iLoading: false,
      wore: false,
      startTime: '',
      isNotStart: true,
      isOver: false,
      creative: null,
      realStartTime: '',
      realEndTime: '',
      agreement: true
    };
  },
  computed: {
    statusText() {
      if (this.isOver) {
        return '活动已结束';
      }
      return this.isNotStart? '活动未开启': '一键佩戴';
    },
    showAgreement() {
      return this.creative &&
        [CAMPAIGN_STATUS.PAUSE.id, CAMPAIGN_STATUS.DELIVERY.id].includes(Number(this.creative['campaign_status'])) &&
        !this.isNotStart &&
        !this.isOver &&
        !this.wore &&
        !this.iLoading;
    },
    iconList() {
      return Object.keys(this.creative['tabbars']).sort().map(i => this.creative['tabbars'][i]);
    }
  },
  mounted() {
    cheka('send', {eventid: CHEKA_EVENTS.PAGE_INIT.id});
    Promise.all([
      creativeService.fetchCreative(POS_MAP.pos_main_bottom_icon.info),
      this.getSuitInfo(),
      this.getVersion()
    ].map(p => p.then(res => res).catch(e => e)))
      .then(([creativeInfo, suitInfo, versionInfo]) => {
        if (creativeInfo && creativeInfo.data) {
          this.creative = creativeInfo.data;
          this.realStartTime = creativeInfo.data['start_time'];
          this.realEndTime = creativeInfo.data['end_time'];
          document.title = creativeInfo.data.title;
        }
        if (suitInfo && suitInfo['skinid']) {
          `${suitInfo['skinid']}`.toUpperCase() === `${this.creative['skin_id']}`.toUpperCase()? this.wore = true: this.wore = false;
        }
        if (versionInfo && versionInfo['from']) {
          const isHigher = this.compareVersion(versionInfo['from']);
          if (!isHigher) {
            this.iLoading = true;
            toast({
              content: '版本太低，请先升级版本！',
              type: 'error'
            });
          }
        }
        this.init();
      }).catch(error => {
        console.log(error);
        cheka('send', {
          eventid: CHEKA_EVENTS.ACTION_FAILD.id,
          eventvalue: {
          'action_type': error.type === 'skin'? 'get_skin_info': 'get_creative_info',
          'action_code': error.code
        }
        });
        toast({
          content: error.message,
          type: 'error'
        });
      });
  },
  methods: {
    init() {
      const currentTime = this.creative['ts']; // Date.parse(new Date()) / 1000;
      if (this.realStartTime) {
        if (currentTime < this.realStartTime) {
          this.isNotStart = true;
        } else {
          this.isNotStart = false;
        }
        this.startTime = dayjs.unix(this.realStartTime).format('YYYY[年]MM[月]DD[日]');
      }
      if (![CAMPAIGN_STATUS.PAUSE.id, CAMPAIGN_STATUS.DELIVERY.id].includes(Number(this.creative['campaign_status']))) {
        this.isNotStart = true;
      }
      if (this.realEndTime) {
        this.isOver = currentTime > this.realEndTime;
      }
      if (this.isOver) {
        this.isNotStart = false;
      }
    },
    showDialog() {
      if (!this.wore) {
        this.onSure();
      } else {
        this.show = !this.show;
        this.iLoading = true;
      }
    },
    putOn() {
      this.iLoading = true;
      cheka('send', {
        eventid: CHEKA_EVENTS.ACTION_SUCCESS.id,
        eventvalue: {
          'action_type': 'before_put_on'
        }
      });
      jsBridge('invoke', 'UseLightSkin', {
        skinid: `${this.creative['skin_id']}`,
        skinversion: '1.0',
        skinurl: this.creative['skin_url'],
        type: 'ad',
        mode: 1,
        end_time: this.creative['end_time'],
        fullSkinID: ''
      }, (res, status) => {
        console.log(res, status);
        if (status) {
          this.handleSendBlog(1);
          this.wore = true;
          cheka('send', {
            eventid: CHEKA_EVENTS.ACTION_SUCCESS.id,
            eventvalue: {
              'action_type': 'put_on_by_bridge',
              uid: this.creative.uid
            }
          });
          toast({
            content: '佩戴成功',
            type: 'success'
          });
        } else {
          this.iLoading = false;
          cheka('send', {
            eventid: CHEKA_EVENTS.ACTION_FAILD.id,
            eventvalue: {
              'action_type': 'put_on_by_bridge',
              res
            }
          });
          toast({
            content: '网络不好，请稍后重试',
            type: 'error'
          });
        }
      });
    },
    onCancel() {
      cheka('send', {eventid: CHEKA_EVENTS.ACTION_CANCEL.id});
      this.iLoading = false;
    },
    onSure() {
      cheka('send', {
        eventid: CHEKA_EVENTS.ACTION_SUCCESS.id,
        eventvalue: {
          'action_type': 'before_take_off'
        }
      });
      jsBridge('invoke', 'UseLightSkin', {
        skinid: '0',
        mode: 1
      }, (res, status) => {
        console.log(res, status);
        if (status) {
          this.iLoading = false;
          this.wore = false;
          this.handleSendBlog(0);
          cheka('send', {
            eventid: CHEKA_EVENTS.ACTION_SUCCESS.id,
            eventvalue: {
              'action_type': 'take_off_by_bridge',
              uid: this.creative.uid
            }
          });
          toast({
            content: '取消成功',
            type: 'success'
          });
          this.goHome();
        } else {
          this.iLoading = false;
          cheka('send', {
            eventid: CHEKA_EVENTS.ACTION_FAILD.id,
            eventvalue: {
              'action_type': 'take_off_by_bridge',
              res
            }
          });
          toast({
            content: '网络不好，请稍后重试',
            type: 'error'
          });
        }
      });
    },
    getSuitInfo() {
      console.log('getSuitInfo');
      return new Promise((resolve) => {
        jsBridge('invoke', 'GetLightSkinInfo', {}, function(res, status) {
          console.log(res, status);
          if (status) {
            resolve(res);
          } else {
            resolve();
          }
        });
      });
    },
    handleSendBlog(setSwitch) {
      const params = {
        active_id: this.creative['active_id'],
        is_feed: this.agreement ? IS_FEED_STATUS.IS_SEND.id : IS_FEED_STATUS.IS_NOT_SEND.id,
        set_switch: setSwitch,
      };
      if (!this.agreement) {
        params.is_feed = IS_FEED_STATUS.IS_NOT_SEND.id;
      }
      creativeService.sendBlog(params)
        .then(() => {
          this.iLoading = false;
          this.goHome();
        })
        .catch(() => {
          cheka('send', {
            eventid: CHEKA_EVENTS.ACTION_FAILD.id,
            eventvalue: {'action_type': 'send_blog'}
          });
          toast({
            content: '网络不好，请稍后重试',
            type: 'error'
          });
        });
    },
    goHome() {
      const channel  = getUrlParam('channel') || '';
      const url = channel === CHANNEL_NAME ? `sinaweibo://browser?url=${encodeURIComponent(CHANNEL_URL)}` : 'sinaweibo://gotohome'
      const timer = setTimeout(() => {
        if(channel !== 'groupSkin') {
          window.location.href = url;
          clearTimeout(timer);
        }
      }, 1500);
    },
    getVersion() {
      console.log('getVersion');
      return new Promise(resolve => {
        jsBridge('invoke', 'getBrowserInfo', {}, function(res, status) {
          console.log(res, status);
          if (status) {
            resolve(res);
          } else {
            resolve();
          }
        });
      });
    },
    compareVersion(version) {
      let source = version.substr(2, 3);
      let target = MIN_VERSION;
      source = parseInt(source[0], 16) * 10000 + parseInt(source[1], 16) * 100 + parseInt(source[2], 16) * 1;
      target = parseInt(target[0], 16) * 10000 + parseInt(target[1], 16) * 100 + parseInt(target[2], 16) * 1;
      cheka('send', {
        eventid: CHEKA_EVENTS.PAGE_INIT.id,
        eventvalue: {'action_type': 'get_version', source, target}
      });
      return source >= target;
    }
  }
}
</script>
